const init = () => {
    const printButton = document.querySelector('.js-print');
    if (printButton) {
        printButton.addEventListener('click', () => {
            window.print();
        });
    }
};

export default init;
